'use client';

import React from 'react';

import { IconSparkles } from '@/assets';
import ListShowcase from '@/contents/ai-model/showcase';
import ToolBar from './tools-bar';
import useFetchToolAI from './useFetch';
import Link from 'next/link';

const Showcase = () => {
  const { listShowcase, currentPage, isLoading, loadMore } = useFetchToolAI();

  return (
    <div className="relative mt-10 sm:mt-7">
      <div className="main-container">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <IconSparkles className="mr-2 sm:scale-80" />
            <p className="text-[24px] sm:text-[20px] font-semibold leading-none">AI Tools</p>
          </div>
          <Link
            href="https://docs.google.com/forms/d/1SdMQDMaFlkDcbysFaaC6xeNmlazY6ldHwhMVEUx4O5Q"
            target="_blank"
            className="h-[40px] hidden sm:h-[34px] rounded-full bg-primary text-white sm:flex sm:items-center px-4 sm:px-3 text-[14px] sm:text-[12px] gap-1"
          >
            <span className="text-[22px] sm:text-[20px] font-light">+</span>
            <span className="font-medium">ComfyFlow</span>
          </Link>
        </div>
        <div className="mt-4 w-full">
          <ToolBar />
        </div>
      </div>
      <ListShowcase
        listShowcase={listShowcase}
        currentPage={currentPage}
        isLoading={isLoading}
        loadMore={loadMore}
      />
    </div>
  );
};

export default Showcase;
